<div class="pnl-tv-dashboard">
  <div>
    <aside>
      <div>
        <span>Pedidos</span>
        <b>{{stats.orders.total | number:'.0'}}</b>
        <div>
          <span>
            <b>{{stats.orders.approved | number:'.0'}}</b>
            <small>Aprovados</small>
          </span>
          <span>
            <b>{{stats.orders.canceled | number:'.0'}}</b>
            <small>Cancelados</small>
          </span>
        </div>
      </div>

      <div>
        <span>Vendas (R$)</span>
        <b>{{stats.sales.total | number:'.0'}}</b>
        <div>
          <span>
            <b>{{stats.sales.approved | number:'.0'}}</b>
            <small>Aprovados</small>
          </span>
          <span>
            <b>{{stats.sales.canceled | number:'.0'}}</b>
            <small>Cancelados</small>
          </span>
        </div>
      </div>

      <div class="loading" *ngIf="loadingTotal">
        <span class="loadingio-spinner-eclipse-cz3y1wre1nd">
          <div class="ldio-ns36390yc">
            <div></div>
          </div>
        </span>
      </div>
    </aside>
    <div id="chart" class="graph">
      <div class="content" [style.width.px]="treemapWidth" [style.height.px]="treemapHeight">
        <div *ngFor="let rectangle of this.result; let i=index"
          [style.width.px]="rectangle.width"
          [style.height.px]="rectangle.height"
          [style.left.px]="rectangle.x"
          [style.top.px]="rectangle.y"
          [class.danger]="rectangle.data.atraso == 'A'"
          [class.warning]="rectangle.data.atraso == 'P'"
          [class.large]="rectangle.height > 300 && rectangle.width > 200"
          [class.normal]="(rectangle.height < 300 && rectangle.height > 150 ) && rectangle.width > 200"
          [class.small]="(rectangle.height < 300 && rectangle.width < 200) || rectangle.width < 200 || rectangle.height < 150"
          [class.xsmall]="rectangle.height < 120"
          [class.horizontal]="rectangle.data.atraso == 'N' && rectangle.height < 100"
          [class.opacity]="rectangle.data.num_orders == 0"
        >
          <h5>{{ rectangle.data.nome }}</h5>
          <span *ngIf="rectangle.data.atraso == 'N'">{{ rectangle.data.num_orders }}</span>
          <span *ngIf="rectangle.data.atraso != 'N'">{{ rectangle.data.pendentes }}</span>
          <b>R$ {{ rectangle.data.receita | number:'.2' }}</b>
        </div>
      </div>
      <div class="loading" *ngIf="loadingSales">
        <div class="loadingio-spinner-eclipse-cz3y1wre1nd">
          <div class="ldio-ns36390yc">
            <div></div>
          </div>
        </div>
      </div>
      <!-- <svg [attr.width]="treemapWidth" [attr.height]="treemapHeight">
        <g
          *ngFor="let rectangle of this.result; let i=index"
          class="treemap__rectangle"
          [attr.fill]="rectangle.data.color"
        >
          <rect
            [attr.x]="rectangle.x"
            [attr.y]="rectangle.y"
            [attr.width]="rectangle.width"
            [attr.height]="rectangle.height"
          ></rect>
          <text
            [attr.x]=getXText(rectangle)
            [attr.y]=getYText(rectangle)
            fill="white"
          >
            {{ rectangle.data.label }}
          </text>
        </g>
        Sorry, your browser does not support inline SVG.
      </svg> -->

    </div>
  </div>
  <footer>
    <a (click)="toogleMenu()">
      <fa-icon [icon]="faBars"></fa-icon>
    </a>
    <div class="slider">
      <div class="slide-track" [style.animation-duration.s]="evaluations.length * 20" [class.slide-track-3]="evaluations.length < 3">
        <div
          *ngFor="let evaluation of evaluations; let i=index"
          class="slide alert"
          [class.danger]="evaluation.nota < 7"
          [class.warning]="evaluation.nota >= 7">
            {{evaluation.descricao}} * pedido &#8470; {{evaluation.idpedido}} *
        </div>

        <!-- GHOST -->
        <div
          *ngFor="let evaluation of evaluations; let i=index"
          class="slide alert"
          [class.danger]="evaluation.nota < 7"
          [class.warning]="evaluation.nota >= 7">
            {{evaluation.descricao}} * pedido &#8470; {{evaluation.idpedido}} *
        </div>

        <ng-template [ngIf]="evaluations.length < 3">
          <div
            *ngFor="let evaluation of evaluations; let i=index"
            class="slide alert"
            [class.danger]="evaluation.nota < 7"
            [class.warning]="evaluation.nota >= 7">
              {{evaluation.descricao}} * pedido &#8470; {{evaluation.idpedido}} *
          </div>
        </ng-template>
      </div>
    </div>
  </footer>

  <div class="menu" [class.dnone]="!menuOpen">
    <div>
      <a [routerLink]="['/app/visao-geral']">Voltar para o painel</a>
      <a (click)="toogleMenu()">Fechar</a>
    </div>
  </div>
</div>
